<template>
  <div class="mobile-footer-height d-sm-none"></div>
  <div
    class="more-tabs-bg d-sm-none"
    :class="[showTabs ? 'd-none' : 'd-block']"
    @click="showMoreTabs"
  ></div>
  <div class="mobile-footer d-sm-none">
    <div class="position-relative">
      <div class="p-2">
        <div class="row gx-0 justify-content-between text-center">
          <div class="col">
            <a
              @click="$router.push('/home')"
              :class="{ active: currentRoute === '/home' || currentRoute === null }"
            ><i class="bi bi-house"></i>首頁</a>
          </div>
          <div class="col">
            <a
              @click="$router.push('/news')"
              :class="{
              active:
                currentRoute === '/news' || currentRoute === '/news/content'
            }"
            ><i class="bi bi-chat-dots"></i>最新訊息</a>
          </div>
          <div class="col">
            <a
              @click="$router.push('/single-course')"
              :class="{
                active:
                  currentRoute === '/course' ||
                  currentRoute === '/course/ordersResult' ||
                  currentRoute === '/single-course' ||
                  currentRoute === '/single-course/ordersResult'
              }"
            ><i class="bi bi-easel2"></i>課程報名</a>
          </div>
          <div class="col">
            <a
              @click="$router.push('/venue-booking/generally')"
              :class="{
              active:
                currentRoute === '/venue-booking/generally' ||
                currentRoute === '/venue-booking/generally/confirm' ||
                currentRoute === '/venue-booking/generally/ordersResult' ||
                currentRoute === '/venue-booking/season' ||
                currentRoute === '/venue-booking/season/confirm' ||
                currentRoute === '/venue-booking/season/success'
            }"
            ><i class="bi bi-pin-map"></i>場地預約</a>
          </div>
          <div class="col">
            <a
              @click="showMoreTabs"
            ><i class="bi bi-three-dots-vertical"></i>更多</a>
          </div>
        </div>
      </div>
      <div class="more-tabs">
        <div class="position-relative">
          <div
            :class="[showTabs ? 'd-none' : 'd-block']"
            class="more-tabs-box"
          >
            <a
              v-if="token"
              @click="logout()"
            ><i class="bi bi-door-open"></i>登出</a>
            <a
              v-if="token"
              @click="navClick('/member')"
              :class="{
              active:
                currentRoute === '/member' ||
                currentRoute === '/member/profile-info' ||
                currentRoute === '/member/coaching-sessions' ||
                currentRoute === '/member/calendar' ||
                currentRoute === '/member/periodical' ||
                currentRoute === '/member/single-pass' ||
                currentRoute === '/member/one-time-ticket' ||
                currentRoute === '/member/ad-hoc-rental' ||
                currentRoute === '/member/course-points' ||
                currentRoute === '/change-password'
            }"
            ><i class="bi bi-person-vcard"></i>會員中心</a>
            <a
              v-if="!token"
              @click="navClick('/login')"
              :class="{ active: currentRoute === '/login' }"
            >
              <i class="bi bi-person-circle me-1"></i>
              登入
            </a>
            <a
            @click="navClick('/shop')"
              :class="{
              active:
                currentRoute === '/shop' ||
                currentRoute === '/shop/ordersResult'
            }"
            ><i class="bi bi-cart2"></i>線上購買</a>
            <a
              href="#"
              @click="fetchBrandsList(), this.brandsDialogVisible = true, showMoreTabs()"
              :class="{ active: isBrandPopupVisible }"
            ><i class="bi bi-diagram-3"></i>切換品牌</a>
          </div>
          <div class="qrcode-position d-md-none" v-if="token">
            <div class="ratio ratio-1x1 w-60px">
              <button
                class="btn btn-qrcode"
                @click="triggerGetQRFunc()"
              >
                <i class="bi bi-qr-code-scan m-auto"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <QRCodeModal
    v-model="ticketQRDialogVisible"
    ref="childComponent"
  />
  <Venue
    v-model="brandsDialogVisible"
    :intro="brands"
    :loading="brandsListLoading"
  />
</template>
<script>
import { getUserRealName, getToken, getSiteId, getBrandId } from '@/utils/auth'
import { GetBrandList } from '@/api/brand'
import Venue from '@/components/Venue.vue'
import QRCodeModal from '@/components/QRCode.vue'

export default {
  name: 'FooterMobile',
  components: { QRCodeModal, Venue },
  data() {
    return {
      showFooter: true,
      brandId: getBrandId(),
      siteId: getSiteId(),
      showTabs: 'd-none',
      currentRoute: this.$route.path,
      token: getToken(),
      isBrandPopupVisible: false,
      brands: [],
      brandsListLoading: false,
      brandSiteListBriefLoading: false,
      brandsDialogVisible: false,
      ticketQRDialogVisible: false
    }
  },
  watch: {
    $router: {
      handler() {
        const realName = getUserRealName()
        if (realName !== undefined) {
          this.userRealName = realName
        }
        this.token = getToken()
      },
      deep: true,
      immediate: true
    },
    $route(to) {
      this.currentRoute = to.path
    }
  },
  created() {
    this.currentRoute = this.$route.path
  },
  mounted() {
    if (!this.currentRoute) {
      this.currentRoute = this.$router.path || null
    }
  },
  methods: {
    triggerGetQRFunc() {
      this.ticketQRDialogVisible = true
      this.$refs.childComponent.getQR()
    },
    showMoreTabs() {
      this.showTabs = !this.showTabs
    },
    navClick(route) {
      this.showMoreTabs()
      this.$router.push(route)
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push('/login')
      this.userRealName = ''
      this.showMoreTabs()
    },
    async fetchBrandsList() {
      if (this.brands.length !== 0) {
        return
      }
      this.brandsListLoading = true
      await GetBrandList(this.brandId)
        .then((result) => {
          const { data } = result
          this.brands = data
        })
        .finally(() => {
          this.brandsListLoading = false
        })
    }
  }
}
</script>
